<template>
  <v-dialog
  v-model="dialogEdit"
   max-width="500px"
  >
   <v-card>
     <v-card-title class="title-card">
       <span class="text-h5">{{ formTitle }}</span>
     </v-card-title>

     <v-card-text>
       <v-container>
         <v-form
            ref="form"
            v-model="valid"
          >
          <v-row>
            <v-col
              class="d-flex"
              cols="12"
              sm="12"
              md="12"
            >
              <v-select
                v-model="obj.empresa.id"
                :items="getEmpresas"
                :rules="nameRules"
                :item-value="'id'"
                :item-text="'nome'"
                outlined
                label="Empresa"
              ></v-select>
            </v-col>
            <v-col
              class="d-flex"
              cols="12"
              sm="12"
              md="12"
            >
              <v-select
                v-model="obj.obra.id"
                :items="getObras"
                :rules="nameRules"
                :item-text="'nome'"
                :item-value="'id'"
                outlined
                label="Unidades"
              ></v-select>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="12"
            >
              <v-text-field
                v-model="obj.descricao"
                :rules="nameRules"
                label="Descrição"
                required
                outlined
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="12"
            >
              <v-text-field
                v-model="obj.data_entrada"
                v-mask="'##/##/####'"
                required
                :rules="nameRules"
                label="Data de entrada"
                outlined
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="12"
            >
              <v-text-field
                v-model="obj.nfe"
                required
                :rules="nameRules"
                label="NFE"
                outlined
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="12"
            >
              <v-text-field
                v-model="obj.valor"
                required
                :rules="nameRules"
                label="Valor"
                outlined
                type="number"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="obj.link_google_drive"
                label="Link GOOGLE DRIVE - NOTA"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="obj.link_google_drive_2"
                label="Link GOOGLE DRIVE - NOTA - 2"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="obj.link_google_drive_3"
                label="Link GOOGLE DRIVE - NOTA - 3"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="obj.link_google_drive_comprovante"
                label="Link GOOGLE DRIVE - COMPROVANTE"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="obj.link_google_drive_comprovante_2"
                label="Link GOOGLE DRIVE - COMPROVANTE - 2"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="obj.link_google_drive_comprovante_3"
                label="Link GOOGLE DRIVE - COMPROVANTE - 3"
                outlined
              ></v-text-field>
            </v-col>

            <v-col cols="12" class="mt-0 pt-0" v-if="obj.link_google_drive">
              <a :href="obj.link_google_drive" target="_blank">Arquivo - GOOGLE DRIVE - NOTA</a>
            </v-col>
            <v-col cols="12" class="mt-0 pt-0" v-else>
              <span>Documento não cadastrado -  NOTA</span>
            </v-col>
            <v-col cols="12" class="mt-0 pt-0" v-if="obj.link_google_drive_2">
              <<a :href="obj.link_google_drive_2" target="_blank">>Arquivo - GOOGLE DRIVE - NOTA - 2</a>
            </v-col>
            <v-col cols="12" class="mt-0 pt-0" v-else>
              <span>ocumento não cadastrado -  NOTA - 2</span>
            </v-col>
            <v-col cols="12" class="mt-0 pt-0" v-if="obj.link_google_drive_3">
              <a :href="obj.link_google_drive_3" target="_blank">Arquivo - GOOGLE DRIVE - NOTA - 3</a>
            </v-col>
            <v-col cols="12" class="mt-0 pt-0" v-else>
              <span>ocumento não cadastrado -  NOTA - 3</span>
            </v-col>
            <v-col cols="12" class="mt-0 pt-0" v-if="obj.link_google_drive_comprovante">
              <a :href="obj.link_google_drive_comprovante" target="_blank">Arquivo - GOOGLE DRIVE - COMPROVANTE</a>
            </v-col>
            <v-col cols="12" class="mt-0 pt-0" v-else>
              <span>Documento não cadastrado -  Comprovante</span>
            </v-col>
            <v-col cols="12" class="mt-0 pt-0" v-if="obj.link_google_drive_comprovante_2">
              <a :href="obj.link_google_drive_comprovante_2" target="_blank">Arquivo - GOOGLE DRIVE - COMPROVANTE - 2</a>
            </v-col>
            <v-col cols="12" class="mt-0 pt-0" v-else>
              <span>Documento não cadastrado -  Comprovante - 2</span>
            </v-col>
            <v-col cols="12" class="mt-0 pt-0" v-if="obj.link_google_drive_comprovante_3">
              <a :href="obj.link_google_drive_comprovante_3" target="_blank">Arquivo - GOOGLE DRIVE - COMPROVANTE - 3</a>
            </v-col>
            <v-col cols="12" class="mt-0 pt-0" v-else>
              <span>Documento não cadastrado -  Comprovante - 3</span>
            </v-col>
          </v-row>
        </v-form>
       </v-container>
     </v-card-text>

     <v-card-actions>
       <v-spacer></v-spacer>
       <v-btn
         color="primary"
         text
         @click="closeEditItem"
       >
         Cancelar
       </v-btn>
       <v-btn
         dark
         color="primary"
         @click="save"
       >
         Salvar
       </v-btn>
     </v-card-actions>
   </v-card>
 </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
export default {
  /* eslint-disable */
 props:{
    dialogEdit: Boolean,
    objValue: Object,
   },
   data () {
      return {
        valid:false,
        formTitle:'Editar',
        nameRules: [
            v => !!v || 'Campo requirido',
        ],
        dialog: false,
        obj: {
          empresa: {
          id: null
          },
          data_entrada: '',
          descricao:'',
          nfe:'',
          valor:'',
        },
      }
   },
   async created () {
    await this.getAllEmpresas ()
    await this.getAllObras ()
    this.obj = this.objValue
  },
  /* eslint-disable */
  watch: {
    objValue(){
      this.obj = this.objValue
    }
  },
  computed: {
      ...mapGetters('empresa', {getEmpresas:'getList'}),
      ...mapGetters('obra', {getObras:'getList'}),
    },
   methods: {
     ...mapActions('entrada', ['updateEntrada']),
     ...mapActions('empresa', {getAllEmpresas:'getAllEmpresas'}),
    async save() {
        this.$refs.form.validate()
        /* eslint-disable no-console */
        if (this.valid) {
          try {
            await this.updateEntrada({
              ...this.obj,
              empresa:{
                id: this.obj.empresa.id,
                nome: this.getEmpresas.find((item) => item.id === this.obj.empresa.id).nome
              },
            })
        } catch (error) {
            console.error(error);
        } finally {
          this.$emit('searchByFilter')
          this.closeEditItem();
        }
      }
    },
    closeEditItem () {
      this.$emit('closeEditItem')
    },
  }
}
</script>
